import { useTheme } from '../../styles/ThemeContext';
import { Field } from '../../components/forms/Field';

/**
 * Step 2: Shipping Units Management
 */
export function Step2ShippingUnits({
  unitTypes, units, newUnit, onNewUnitChange, onUnitTypeChange, onAddUnit, onUpdateUnit, onEditUnit, onCancelEdit, onRemoveUnit, editingUnitId, products, onBack, onNext
}) {
  const { theme } = useTheme();
  const c = theme.colors;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
        <span style={theme.sectTag}>STEP 02</span>
        <h2 style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>Shipping Units</h2>
      </div>

      <div style={theme.card}>
        <div style={{ fontSize: 9, color: c.accent, letterSpacing: 1, marginBottom: 12, fontFamily: 'monospace' }}>
          {editingUnitId ? 'EDIT UNIT ──────────' : 'ADD NEW UNIT ──────────'}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 10, marginBottom: 10 }}>
          <Field l="Unit Type"><select value={newUnit.type} onChange={(e) => onUnitTypeChange(e.target.value)} style={theme.sel}>{unitTypes.map((u) => (<option key={u.type}>{u.type}</option>))}</select></Field>
          <Field l="Unit Number"><input value={newUnit.number} onChange={(e) => onNewUnitChange('number', e.target.value)} style={theme.inp} /></Field>
          <Field l="Tare (kg)"><input value={newUnit.tare} onChange={(e) => onNewUnitChange('tare', e.target.value)} style={theme.inp} /></Field>
          <Field l="Export Type"><select value={newUnit.export_type || 'Temporary'} onChange={(e) => onNewUnitChange('export_type', e.target.value)} style={theme.sel}><option value="Temporary">Temporary</option><option value="Permanent">Permanent</option></select></Field>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 10, marginBottom: 14 }}>
          <Field l="Length (cm)"><input value={newUnit.length} onChange={(e) => onNewUnitChange('length', e.target.value)} style={theme.inp} /></Field>
          <Field l="Width (cm)"><input value={newUnit.width} onChange={(e) => onNewUnitChange('width', e.target.value)} style={theme.inp} /></Field>
          <Field l="Height (cm)"><input value={newUnit.height} onChange={(e) => onNewUnitChange('height', e.target.value)} style={theme.inp} /></Field>
          <Field l="Total Weight (kg)"><input value={newUnit.totalWeight} onChange={(e) => onNewUnitChange('totalWeight', e.target.value)} placeholder="Optional" style={theme.inp} /></Field>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          {editingUnitId ? (
            <>
              <button onClick={onUpdateUnit} style={{ ...theme.btnSm, background: c.success }}>✓ Update Unit</button>
              <button onClick={onCancelEdit} style={theme.btnG}>Cancel</button>
            </>
          ) : (
            <button onClick={onAddUnit} style={theme.btnSm}>+ Add Unit</button>
          )}
        </div>
      </div>

      {units.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: c.textSecondary, background: c.bgCard, border: '1px solid ' + c.border, borderRadius: 4 }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>📦</div>
          <div>No shipping units added yet</div>
        </div>
      ) : (
        <div style={{ background: c.bgCard, border: '1px solid ' + c.border, borderRadius: 4, overflow: 'hidden', marginBottom: 12 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: c.bgInput }}>
                {['#', 'Type', 'Nr', 'L × W × H', 'Tare (kg)', 'Total (kg)', 'Export Type', 'Products', ''].map((h) => (
                  <th key={h} style={{ textAlign: 'left', padding: '7px 10px', fontSize: 9, fontFamily: 'monospace', color: c.textSecondary, letterSpacing: 1, borderBottom: '1px solid ' + c.border }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {units.map((u, i) => (
                <tr key={u.id} style={{ borderBottom: '1px solid ' + c.border }}>
                  <td style={{ padding: '9px 10px', fontFamily: 'monospace', color: c.accent, fontSize: 11 }}>{String(i + 1).padStart(2, '0')}</td>
                  <td style={{ padding: '9px 10px', fontWeight: 500 }}>{u.type}</td>
                  <td style={{ padding: '9px 10px' }}><span style={{ background: c.badge, padding: '2px 8px', fontSize: 10, fontFamily: 'monospace', borderRadius: 2 }}>{u.number}</span></td>
                  <td style={{ padding: '9px 10px', fontFamily: 'monospace', fontSize: 11 }}>{u.length} × {u.width} × {u.height}</td>
                  <td style={{ padding: '9px 10px', fontFamily: 'monospace', fontSize: 11 }}>{u.tare}</td>
                  <td style={{ padding: '9px 10px', fontFamily: 'monospace', fontSize: 11 }}>{u.totalWeight || '—'}</td>
                  <td style={{ padding: '9px 10px', fontSize: 11 }}>
                    <span style={{ background: u.export_type === 'Permanent' ? c.purpleBg : c.infoBg, color: u.export_type === 'Permanent' ? c.purple : c.info, padding: '2px 8px', borderRadius: 2, fontSize: 10, fontFamily: 'monospace' }}>{u.export_type || 'Temporary'}</span>
                  </td>
                  <td style={{ padding: '9px 10px', fontSize: 11, color: c.textSecondary }}>{products.filter((p) => p.unitId === u.id).length} items</td>
                  <td style={{ padding: '9px 10px' }}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button onClick={() => onEditUnit(u.id)} style={{ ...theme.btnG, padding: '4px 10px', fontSize: 11 }}>✏️ Edit</button>
                      <button onClick={() => onRemoveUnit(u.id)} style={{ ...theme.btnDanger, padding: '4px 10px', fontSize: 11 }}>× Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, paddingTop: 16, borderTop: '1px solid ' + c.border }}>
        <button onClick={onBack} style={theme.btnG}>← Back</button>
        <button onClick={onNext} disabled={units.length === 0} style={{ ...theme.btnP, opacity: units.length ? 1 : 0.4, cursor: units.length ? 'pointer' : 'not-allowed' }}>Next: Products →</button>
      </div>
    </div>
  );
}
